import { Component, OnInit } from '@angular/core';
import { AlertController, LoadingController, ToastController } from '@ionic/angular';
import { AuthService } from '../../services/auth.service';
import { SpreaderPayoutMethod, SpreaderPayoutMethodService } from '../../services/spreader-payout-method.service';

@Component({
  selector: 'app-payout-methods',
  templateUrl: './payout-methods.page.html',
  styleUrls: ['./payout-methods.page.scss'],
  standalone: false,
})
export class PayoutMethodsPage implements OnInit {
  loading = false;
  vendedorId: string = '';
  current: SpreaderPayoutMethod | null = null;

  // form fields
  metodoSelecionado: 'Zelle' | 'ContaBancaria' | 'ContaInternacional' = 'Zelle';
  zelleNome = '';
  zelleEmailOrPhone = '';
  zelleBanco = '';
  ssn = '';
  taxId = '';

  constructor(
    private auth: AuthService,
    private payoutService: SpreaderPayoutMethodService,
    private loadCtrl: LoadingController,
    private alertCtrl: AlertController,
    private toastCtrl: ToastController,
  ) {}

  async ngOnInit() {
    const user = (await this.auth.dataAuth()) as any;
    this.vendedorId = user?.id ?? user?.userId ?? '';
    await this.load();
  }

  ionViewWillEnter() {
    if (this.vendedorId) this.load();
  }

  async load() {
    if (!this.vendedorId) return;
    this.loading = true;
    const loading = await this.loadCtrl.create({ message: 'Loading...' });
    await loading.present();
    this.payoutService.getMine(this.vendedorId).subscribe({
      next: (res: any) => {
        this.current = res;
        if (res?.zelle) {
          this.metodoSelecionado = (res.metodoSelecionado as any) || 'Zelle';
          this.zelleNome = res.zelle?.nomeCompleto || '';
          this.zelleEmailOrPhone = res.zelle?.emailOuTelefone || '';
          this.zelleBanco = res.zelle?.nomeBanco || '';
          this.ssn = res.ssn || '';
          this.taxId = res.taxId || '';
        }
        this.loading = false;
        loading.dismiss();
      },
      error: () => { this.loading = false; loading.dismiss(); },
    });
  }

  async save() {
    if (this.metodoSelecionado === 'Zelle' && (!this.zelleNome || !this.zelleEmailOrPhone)) {
      const t = await this.toastCtrl.create({ message: 'Please fill name and email/phone for Zelle.', duration: 2500, position: 'bottom' });
      await t.present();
      return;
    }
    const payload: SpreaderPayoutMethod = {
      vendedorId: this.vendedorId,
      ssn: this.ssn || undefined,
      taxId: this.taxId || undefined,
      zelle: this.metodoSelecionado === 'Zelle' ? {
        selecionado: true,
        nomeCompleto: this.zelleNome,
        emailOuTelefone: this.zelleEmailOrPhone,
        nomeBanco: this.zelleBanco,
      } : undefined,
      metodoSelecionado: this.metodoSelecionado,
    };

    const loading = await this.loadCtrl.create({ message: 'Saving...' });
    await loading.present();

    const obs = this.current?.id
      ? this.payoutService.update(this.current.id, payload)
      : this.payoutService.create(payload);

    obs.subscribe({
      next: async () => {
        loading.dismiss();
        const t = await this.toastCtrl.create({ message: 'Saved.', duration: 2000, position: 'bottom' });
        await t.present();
        await this.load();
      },
      error: async () => {
        loading.dismiss();
        const t = await this.toastCtrl.create({ message: 'Failed to save.', duration: 2500, position: 'bottom' });
        await t.present();
      },
    });
  }

  async deleteMethod() {
    if (!this.current?.id) return;
    const alert = await this.alertCtrl.create({
      header: 'Delete payout method?',
      message: 'This action cannot be undone.',
      buttons: [
        { text: 'Cancel', role: 'cancel' },
        {
          text: 'Delete',
          role: 'destructive',
          handler: () => {
            this.payoutService.delete(this.current!.id!).subscribe({
              next: async () => {
                this.current = null;
                this.zelleNome = this.zelleEmailOrPhone = this.zelleBanco = this.ssn = this.taxId = '';
                const t = await this.toastCtrl.create({ message: 'Method deleted.', duration: 2000, position: 'bottom' });
                await t.present();
              },
              error: async () => {
                const t = await this.toastCtrl.create({ message: 'Failed to delete.', duration: 2500, position: 'bottom' });
                await t.present();
              },
            });
          },
        },
      ],
    });
    await alert.present();
  }
}
